import { render, staticRenderFns } from "./OrganizationParties.vue?vue&type=template&id=0f3ca6fe"
import script from "./OrganizationParties.vue?vue&type=script&lang=js"
export * from "./OrganizationParties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports